var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminCoreProvider = exports.AdminCoreContext = void 0;
const react_1 = __importStar(require("react"));
const initial_state_1 = require("./initial-state");
const reducer_1 = require("./reducer");
const initialDispatch = () => {
    console.log('Error: admin core context value not found');
};
exports.AdminCoreContext = react_1.createContext({
    adminCoreState: initial_state_1.initialState,
    adminCoreDispatch: initialDispatch,
});
exports.AdminCoreProvider = (props) => {
    const [adminCoreState, adminCoreDispatch] = react_1.useReducer(reducer_1.mainReducer, initial_state_1.initialState);
    return (react_1.default.createElement(exports.AdminCoreContext.Provider, { value: { adminCoreState, adminCoreDispatch } }, props.children));
};
//# sourceMappingURL=admin-core-provider.js.map